import React from 'react'
import styled from '@emotion/styled'
import { Link, useNavigate } from 'react-router'
import { Button } from '@mobi/component-library/Base/Buttons'
import { Icon } from '@mobi/component-library/Assets/Icon'
import { Icon as IconLegacy } from '@mobi/component-library/Legacy/Icon'
import { colors, font, radius, spacing } from '@mobi/component-library/Foundations'
import { getHostHelpers } from '@mobi/betslip/helpers/hostHelpers'

export const EmptyState = () => {
  const hostHelpers = getHostHelpers()
  const navigate = useNavigate()

  return (
    <WrapperStyled>
      <div>
        <div>
          <Icon color={colors.neutral[400]} name='CustomBetSlipWithTabtouchLogo' size='9.5rem' />
        </div>
        <h1>Your Bet Slip is Empty</h1>
        <span>Check out today&apos;s racing</span>
      </div>

      <div>
        <Link to={hostHelpers.hostRoutes.Meetings}>
          <RacingButtonLink
            onClick={() => hostHelpers.toggleBetSlipDrawer?.(false)}
            navigate={() => navigate(hostHelpers.hostRoutes.Meetings)}
          />
        </Link>
      </div>
    </WrapperStyled>
  )
}

const RacingButtonLink = React.forwardRef<
  HTMLButtonElement,
  { onClick: () => void; navigate: () => void }
>(({ ...props }, ref) => (
  <Button
    ref={ref}
    {...props}
    onClick={() => {
      props.navigate()
      props.onClick()
    }}
    color='secondary_color'
    size='sm'
  >
    <IconLegacy type='racesall' size='2rem' />
    Today&apos;s Racing
  </Button>
))
RacingButtonLink.displayName = 'RacingButtonLink'

const WrapperStyled = styled.div({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  gap: '1.9rem',
  maxWidth: '20.8rem',
  margin: 'auto',

  'div:nth-of-type(1)': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    '> div': {
      background: colors.surface[200],
      borderRadius: radius.full,
      height: '16.4rem',
      width: '16.4rem',
    },

    h1: {
      ...font.size.lg,
      fontWeight: font.weight.semibold,
      fontFamily: font.family.primary,
    },

    span: {
      ...font.size.lg,
      fontWeight: font.weight.regular,
    },
  },

  'div:nth-of-type(2)': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: spacing.smx1,
  },
})
